import ReactDOM from 'react-dom/client';
// import { Provider } from 'react-redux';
import App from './App';
import './bootstrap/bootstrap-5.3.3-dist/css/bootstrap.min.css';
// import './component/multiLanguage/i18next';
import './index.css';

// import { store } from './store/redux-store'; // Ensure you import the correct store

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <Provider store={store}>
    <App />
  // </Provider> 
  );

  /*
  done   1 - watch video manual route , test on userOpen Lecture   
  done   2 - Quiz manual route , test on user
    3 - convert sandbox into live paypal 
  done   4 - test user registration and login
    5 - test CRUD operation on course , lecture and assignment
    6 - test try add course to user successfully 
    7 - all senarios of course description and course description
    8 - try to find best photos to this website
    9 - test the search function
    10 - secure my API
    11 - test DB secure connection
  */